// extracted by mini-css-extract-plugin
export default {"form":"CreateNewPassword_form__ah5xI","title":"CreateNewPassword_title__L5mNc","button":"CreateNewPassword_button__hk7H7","description":"CreateNewPassword_description__Rte3c"};